import { ShieldAlert, ShieldCheck } from "lucide-react";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { useDashboardWidget } from "@/lib/hooks/use-dashboard";
import { useT } from "@/lib/i18n/use-t";
import { useDashboardFormat } from "../use-dashboard-format";
import { T } from "./approvals-waiting-widget.i18n";
import { ListRow } from "./list-row";
import { WidgetCard } from "./widget-card";
import { WidgetEmpty } from "./widget-empty";

export function ApprovalsWaitingWidget({ target }: { target: DashboardTarget }) {
  const { data, isLoading, error } = useDashboardWidget("approvals_waiting", target);
  const t = useT(T);
  const { count, relative } = useDashboardFormat();

  return (
    <WidgetCard
      icon={ShieldCheck}
      title={t.approvalsWaiting}
      description={t.approvalsWaitingDescription}
      badge={data ? count(data.total) : undefined}
      footer={{ label: t.openApprovals, to: "/compliance/approvals" }}
      isLoading={isLoading}
      error={error}
    >
      {data &&
        (data.items.length === 0 ? (
          <WidgetEmpty>{t.noApprovals}</WidgetEmpty>
        ) : (
          <div className="space-y-3">
            {data.items.map((item) => (
              <ListRow
                key={item.approvalId}
                icon={ShieldAlert}
                tone="warning"
                title={item.clientName}
                detail={item.flowName}
                meta={t.requestedBy(item.requestedByName ?? "—", relative(item.requestedAt))}
                to={item.link}
              />
            ))}
          </div>
        ))}
    </WidgetCard>
  );
}
